import React, { useEffect } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import { sharedExtensions } from "./extensions";
import "./tiptap.css";

export function parseContent(raw) {
	if (!raw) return { type: "doc", content: [{ type: "paragraph" }] };
	try {
		const parsed = JSON.parse(raw);
		if (parsed && parsed.type === "doc") return parsed;
		throw new Error("not a tiptap doc");
	} catch {
		// Retrocompatibilidade: conteúdo salvo como texto puro antes da migração
		const lines = raw.split("\n");
		return {
			type: "doc",
			content: lines.map((line) => ({
				type: "paragraph",
				content: line.trim() ? [{ type: "text", text: line }] : [],
			})),
		};
	}
}

export default function TipTapViewer({ content }) {
	const editor = useEditor({
		extensions: sharedExtensions,
		content: parseContent(content),
		editable: false,
	});

	useEffect(() => {
		if (editor && !editor.isDestroyed)
			editor.commands.setContent(parseContent(content));
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [content]);

	return (
		<div className="tiptap-content">
			<EditorContent editor={editor} />
		</div>
	);
}
